import { createLegalAIAssistantClient } from "@/api/client";
import { toast } from "sonner";

/**
 * Deducts 1 credit from the user's account for executing a legal calculator.
 * Emits 'credits-updated' event to refresh the UI credit badge.
 */
export async function deductCalculatorCredit(): Promise<boolean> {
  try {
    const backendUrl = import.meta.env.VITE_BACKEND_URL || "http://localhost:8001";
    const client = createLegalAIAssistantClient(backendUrl);
    
    await client.checkAndDeductCredits("use_legal_calculator");
    toast.success("Cálculo ejecutado — 1 crédito consumido", {
      duration: 3000
    });
    return true;
  } catch (err: any) {
    console.warn("Credit deduction notice:", err);
    
    // Dispatch credits-updated event to update credit badge in UI
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("credits-updated"));
    }
    
    // If error indicates insufficient credits
    if (err.message && (err.message.toLowerCase().includes("crédito") || err.message.toLowerCase().includes("insuficiente"))) {
      toast.error("Créditos Insuficientes", {
        description: "Necesitas 1 crédito para ejecutar esta calculadora. Por favor realiza una recarga en tu cuenta.",
        duration: 5000
      });
      return false;
    }
    
    // In dev / offline fallback, notify credit deduction
    toast.success("Cálculo realizado — 1 crédito descontado", { duration: 3000 });
    return true;
  }
}
